import types from './action-types';

const initialState = {
    charts: {},
};

const updateObject = (oldObject, updatedValues) => {
    return {
        ...oldObject,
        ...updatedValues
    }
};

export default (state = initialState, action) => {
    let newState = state;

    switch (action.type) {
        case types.DATA_LOADED:
            const { chartName, chartData: { dataSets, scalingSettings } } = action;
            const modifiedCharts = { ...state.charts };
            modifiedCharts[chartName] = {
                processing: false,
                data: {
                    datasets: dataSets,
                    scalingSettings: scalingSettings
                },
            };

            newState = updateObject(state, { charts: modifiedCharts })
            break;
        case types.CLEAR_CHART_STATE:
            delete state.charts[action.chartName];
            break;
    }

    return newState;
}



// WEBPACK FOOTER //
// ./App/components/modules/measurement-chart/reducer.js